import React from "react";
import { use } from "react";
import useFolderFileStore from "../../store/folderFileStore";
import DroppableWrapper from "../../dnd/DroppableWrapper";
import {
  useProLanguage,
  PRO_TRANSLATIONS,
} from "../../global/ProLanguageContext";

const FolderBreadcrumb = ({ size = "default", truncate = 0 }) => {
  const { lang } = useProLanguage();
  const t = PRO_TRANSLATIONS[lang].media;

  const selectedFolderID = useFolderFileStore(
    (state) => state.selectedFolderID,
  );
  const folderFileDatas = useFolderFileStore((state) => state.folderFileDatas);
  const setSelectedFolderID = useFolderFileStore(
    (state) => state.setSelectedFolderID,
  );
  // if (!path || path.length === 0) {
  //   return (
  //     <div style={{ padding: "8px 12px", color: "#888" }}>No path</div>
  //   );
  // }

  const path = [];
  let currentFolderID = selectedFolderID;

  while (currentFolderID) {
    const folder = folderFileDatas.find((f) => f.FolderID === currentFolderID);
    if (folder) {
      path.unshift({ name: folder.FolderName, id: folder.FolderID });
      currentFolderID = folder.FolderParentID;
    } else {
      break;
    }
  }
  path.unshift({ name: t.panelRoot, id: null });

  const preDisplayPath = path.map((folder, index) => {
    const isLast = index === path.length - 1;
    return (
      <React.Fragment key={folder.id || index}>
        <DroppableWrapper
          id={`breadcrumb_${folder.id}`}
          data={{
            type: "breadcrumb",
            id: folder.id,
            name: folder.name,
          }}
          style={{ flexShrink: 0 }}
        >
          <span
            style={{
              cursor: !isLast ? "pointer" : "default",
              color: !isLast ? "#007bff" : "#000",
              fontWeight: isLast ? "bold" : "normal",
              whiteSpace: "nowrap",
              display: "block",
            }}
            onClick={() => {
              console.log("on crumc click " + folder.id);
              setSelectedFolderID(folder.id);
            }}
          >
            {folder.name}
          </span>
        </DroppableWrapper>
        {!isLast && <span style={{ color: "#999", flexShrink: 0 }}>/</span>}
      </React.Fragment>
    );
  });

  const displayPath =
    truncate && preDisplayPath.length > truncate
      ? [
          preDisplayPath[0],
          preDisplayPath[1],
          <span>...</span>,
          <span style={{ color: "#999" }}>/</span>,
          preDisplayPath[preDisplayPath.length - 2],
          preDisplayPath[preDisplayPath.length - 1],
        ]
      : [...preDisplayPath];

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "nowrap",
        alignItems: "center",
        gap: "6px",
        padding: "8px 12px",
        overflowX: "auto",
        minWidth: 0,
        fontSize: size == "default" ? "18px" : "14px",
      }}
    >
      {displayPath}
    </div>
  );
};

export default FolderBreadcrumb;
